<template>
  <v-container>
    <v-toolbar dense flat color="transparent">
      <v-toolbar-title class="font-weight-bold">New User</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="onCancel()" text>Cancel</v-btn>
      <v-btn @click="onSave()" color="primary" class="ml-2">Save</v-btn>
    </v-toolbar>
    <v-row>
      <v-col cols="6">
        <v-card class="mb-6">
          <v-form ref="createForm">
            <v-card-text class="pb-0">
              <div class="subtitle-2">Username</div>
              <v-text-field
                :rules="[v => !!v || 'This is required']"
                required
                v-model="newItem.username"
                outlined
                hide-details="auto"
                dense
              ></v-text-field>
            </v-card-text>
            <v-card-text class="pb-0">
              <div class="subtitle-2">Email</div>
              <v-text-field
                :rules="[v => !!v || 'This is required']"
                required
                v-model="newItem.email"
                outlined
                hide-details="auto"
                dense
              ></v-text-field>
            </v-card-text>
            <v-card-text class="pb-0">
              <v-switch
                v-model="newItem.is_superuser"
                :label="`Admin access`"
              ></v-switch>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="pb-0">
              <div class="subtitle-2">New Password</div>
              <v-text-field
                v-model="newItem.password"
                required
                :rules="[v => !!v || 'This is required']"
                outlined
                placeholder="Enter Your New Password"
                hide-details="auto"
                dense
                :append-icon="password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="password ? 'text' : 'password'"
                @click:append="password = !password"
              ></v-text-field>
            </v-card-text>
            <v-card-text>
              <div class="subtitle-2">Confirm Password</div>
              <v-text-field
                v-model="newItem.password_repeat"
                required
                :rules="[v => !!v || 'This is required']"
                outlined
                placeholder="Repeat New Password"
                hide-details="auto"
                dense
                :append-icon="confirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="confirmPassword ? 'text' : 'password'"
                @click:append="confirmPassword = !confirmPassword"
              ></v-text-field>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      modelPath: 'users',
      password: false,
      confirmPassword: false,
      newItem: {
        username: "",
        email: "",
        is_superuser: false,
        password: null,
        password_repeat: null,
      },
    };
  },
  methods: {
    onSave: function() {
      if (this.$refs.createForm.validate()) {
        //TODO :- Perform action if the form is validated
        this.postCreateNewItem()
        .then((res) => {
          this.$router.go('/user');
        })
      }
    },
    onCancel() {
      this.$router.go(-1);
    },
    postCreateNewItem: function() {
      return new Promise((resolve) => {
        this.$http({
          method: 'post',
          url: `/${this.modelPath}/`,
          data: this.newItem
        })
        .then(function (response) {
          console.log(response.data)
          let data = response.data
          resolve({
            data
          })
        }).catch(function(err) {
          console.log(err.response)
        })
      })
    },
  }
};
</script>
